'use strict';

const CouponCard = require('./coupon_card');

$(() => {
  const $couponCards = $('#multiple-offers .mpp-coupon-card');

  if (!($couponCards.length > 0)) {
    return;
  }

  for (const el of $couponCards) {
    new CouponCard(el);
  } // We load ZeroClipboard like this so that we only load it when there
  // are coupons on the page, and to avoid adding extra weight to our main JS.

  const script = document.createElement('script');
  script.src = $('#multiple-offers').data('zero-clipboard-js');
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
});
